import { useEffect, useState } from "react";

const useDebounce = (item, timeout) => {
    const [debouncedItem, setDebouncedItem] = useState(item);
  
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedItem(item);
      }, timeout);
  
      return () => {
        clearTimeout(handler);
      };
    }, [item, timeout]);
  
    return debouncedItem;
  };

  export { useDebounce };